import apis from "../../../api";
import setAndGetLocalLang from "../../../utils/setAndGetLocalLang";
import {
  loginAction,
  loginAction2,
  logoutAction,
  preLoginAction,
  lastLoginTimeAction,
} from "../actionCreators/loginActionCreator";
import { setErrorHandler } from "./errorActionHandler";
import { errorTypes } from "../../../utils/errorTypes";
import loaders from "../actionCreators/loadersActionCreator";
import { setTenantNameAction } from "../actionCreators/commonActionCreator";
import { setThemeStylesHandler } from "./commonActionHandler";
import { apiConstants } from "../../../utils/apiConstants";
import * as msal from "@azure/msal-browser";
import { msalConfig } from "../../../utils/msalConfig";
import getTenantName from "../../../utils/getTenantName";
import {
  domains,
  isMatchingDomain,
} from "../../../utils/ltimSSOLoginCondition";
import { isTokenExpired } from "../../../utils/tokenUtils";
import {
  endTrackedSessionOnPageExit,
  endTrackedSessionNow,
  startTrackedSession,
} from "../../../utils/sessionManager";

const { FAIL, SUCCESS, WARN } = errorTypes;

const GoToSAMLloginPage = (samlurl) => {
  let newsamlurl =
    samlurl +
    localStorage.getItem("tenantName") +
    "?username=" +
    localStorage.getItem("userName") +
    "&web=" +
    document.location.href;

  window.location.href = newsamlurl;
};

const saveSAMLConfigAndRedirect = (data) => {
    localStorage.setItem("SAMLconfig", JSON.stringify(data?.SAMLConfig));
  localStorage.setItem("SAML2AuthServiceUrl", data?.SAML2AuthServiceUrl);
  GoToSAMLloginPage(data?.SAML2AuthServiceUrl);
};
const postAADAdminConsentActionHandler =
  (tenantId, clientId, tenantName) => async () => {
    const tenantData = JSON.parse(localStorage.getItem("tenantData"));

    let data = {
      TenantId: tenantId,
      ClientId: clientId,
      TenantName: tenantName,
    };
    await apis.login
      .aadAdminConsent(data)
      .then((response) => {
        return response;
      })
      .then((result) => {
        if (result !== undefined) {
          console.log(result);
          const updatedTenantData = {
            ...tenantData,
            AADConfig: {
              ...tenantData.AADConfig,
              IsAdminConsentGiven: true,
            },
          };
          localStorage.setItem("tenantData", JSON.stringify(updatedTenantData));
        }
      })
      .catch((err) => {
        console.log("Fetch Error", err);
      });
  };

export const getToken = async (loginRequest) => {
  const msalInstance = new msal.PublicClientApplication(msalConfig);

  // Check if the token in localStorage is expired
  const token = isTokenExpired();
  if (token) {
    console.log("Token is expired. Redirecting to login.");
    endTrackedSessionOnPageExit();
    localStorage.clear();
    sessionStorage.clear();
    return;
  }

  console.log(
    "Token is expired or not present. Attempting to acquire a new token."
  );

  return await msalInstance
    .acquireTokenSilent(loginRequest)
    .then((response) => {
      localStorage.setItem("token", `bearer ${response.accessToken}`);
      return response.accessToken;
    })
    .catch((error) => {
      if (error instanceof msal.InteractionRequiredAuthError) {
        msalInstance
          .acquireTokenRedirect(loginRequest)
          .then((response) => {
            localStorage.setItem("token", `bearer ${response.accessToken}`);
            return response.accessToken;
          })
          .catch((popupError) => {
            console.error("Error acquiring token via popup:", popupError);
            // Redirect to login page if popup fails
            msalInstance.loginRedirect(loginRequest);
          });
      } else {
        console.error("Unexpected error acquiring token:", error);
        msalInstance.loginRedirect(loginRequest); // Redirect to login page
      }
    });
};

export const authenticateAADUser = (navigate, location) => (dispatch) => {
  const tenantData = JSON.parse(localStorage.getItem("tenantData"));
  const userName = localStorage.getItem("userName");
  const tenantName = localStorage.getItem("tenantName");
  let loginRequest = {
    scopes: [`${apiConstants.MSAL_CONFIG.LOGIN_RESOURCE}/user_impersonation`],
  };
  if (!tenantData?.ID) {
    localStorage.clear();
    sessionStorage.clear();
    dispatch(setErrorHandler(FAIL, `Data not found, please login again!`));
    navigate("/");
  } else {
    const msalInstance = new msal.PublicClientApplication(msalConfig);
    const user =
      msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
    if (user) {
      loginRequest = {
        ...loginRequest,
        account: user,
      };
    }
    if (tenantData?.AADConfig?.IsAdminConsentGiven === false) {
      loginRequest = {
        ...loginRequest,
        prompt: "consent",
      };
      dispatch(
        postAADAdminConsentActionHandler(
          tenantData?.ID,
          msalConfig.auth.clientId,
          tenantData?.TenantSlugName
        )
      );
    } else {
      loginRequest = {
        ...loginRequest,
        // prompt: "login",
      };
    }
    if (!user) {
      if (userName) {
        loginRequest = {
          ...loginRequest,
          extraQueryParameters: { login_hint: userName },
        };
      }
      const handleResponse = (response) => {
        if (response !== null) {
          msalInstance.setActiveAccount(response.account);
          localStorage.setItem("token", `bearer ${response.accessToken}`);
            // navigate("/aadlogin");
            navigate(`/${tenantName}/home`);

          // dispatch(checkAADToken(navigate));
        } else {
          const currentAccounts = msalInstance.getAllAccounts();
          if (currentAccounts.length === 0) {
            msalInstance.loginRedirect(loginRequest);
          } else if (currentAccounts.length > 1) {
            msalInstance.setActiveAccount(currentAccounts[0]);
            localStorage.setItem("token", `bearer ${response.accessToken}`);
            navigate(`/${tenantName}/home`);
            // navigate("/aadlogin");
            // dispatch(checkAADToken(navigate));
          }
        }
      };
      msalInstance.handleRedirectPromise().then(handleResponse);
    } else {
      getToken(loginRequest)
        .then(() => {
          if (getTenantName(dispatch, location) && isMatchingDomain(domains))
            navigate("/");
          else navigate(`/${tenantName}/home`);
          // navigate("/aadlogin");
          // dispatch(checkAADToken(navigate));
        })
        .catch((error) => {
          if (error.errorCode === "invalid_grant") {
            localStorage.clear(); // Clear local storage
            sessionStorage.clear();
            msalInstance.loginRedirect(loginRequest); // Redirect to login
          } else {
            console.error("Token acquisition error:", error);
          }
        });
    }
  }
};

export const authenticateAADUserForLighthouse =
  (navigate, location) => (dispatch) => {
    const tenantData = JSON.parse(localStorage.getItem("tenantData"));
    const userName = localStorage.getItem("userName");
    const tenantName = localStorage.getItem("tenantName");
    let loginRequest = {
      scopes: [`${apiConstants.MSAL_CONFIG.LOGIN_RESOURCE}/user_impersonation`],
    };
    const msalInstance = new msal.PublicClientApplication(msalConfig);
    const user =
      msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
    if (user) {
      loginRequest = {
        ...loginRequest,
        account: user,
      };
    }
    if (tenantData?.AADConfig?.IsAdminConsentGiven === false) {
      // debugger;
      loginRequest = {
        ...loginRequest,
        prompt: "consent",
      };
      dispatch(
        postAADAdminConsentActionHandler(
          tenantData?.ID,
          msalConfig.auth.clientId,
          tenantData?.TenantSlugName
        )
      );
    } else {
      loginRequest = {
        ...loginRequest,
        // prompt: "login",
      };
    }
    if (!user) {
      if (userName) {
        loginRequest = {
          ...loginRequest,
          extraQueryParameters: { login_hint: userName },
        };
      }
      const handleResponse = (response) => {
        if (response !== null) {
          msalInstance.setActiveAccount(response.account);
          localStorage.setItem("token", `bearer ${response.accessToken}`);
            if (!localStorage.getItem("tenantName") && isMatchingDomain(domains))
              navigate("/");
            else navigate(`/${tenantName}/home`);

          // dispatch(checkAADToken(navigate));
        } else {
          const currentAccounts = msalInstance.getAllAccounts();
          if (currentAccounts.length === 0) {
            msalInstance.loginRedirect(loginRequest);
          } else if (currentAccounts.length > 1) {
            msalInstance.setActiveAccount(currentAccounts[0]);
            localStorage.setItem("token", `bearer ${response.accessToken}`);
            // navigate(`/${tenantName}/home`);
            // navigate("/aadlogin");
            // dispatch(checkAADToken(navigate));
          }
        }
      };
      msalInstance.handleRedirectPromise().then(handleResponse);
    } else {
      getToken(loginRequest)
        .then(() => {
          // debugger;
          if (!localStorage.getItem("tenantName") && isMatchingDomain(domains))
            navigate("/");
          else {
            if (
              isMatchingDomain(domains) &&
              !tenantData?.AADConfig?.IsAdminConsentGiven
            ) {
              msalInstance.loginRedirect(loginRequest).then((res) => {
                // debugger;
                navigate(`/${tenantName}/home`);
              });
            } else navigate(`/${tenantName}/home`);
          }
          // navigate("/aadlogin");
          // dispatch(checkAADToken(navigate));
        })
        .catch((error) => {
          if (error.errorCode === "invalid_grant") {
            endTrackedSessionOnPageExit();
            localStorage.clear(); // Clear local storage
            sessionStorage.clear();
            msalInstance.loginRedirect(loginRequest); // Redirect to login
          } else {
            console.error("Token acquisition error:", error);
          }
        });
    }
  };

export const getTenantDetailsActionHandler =
  (tenantName, userName) => async (dispatch) => {
    dispatch(loaders.common.pageLoader(true));
    await apis.login
      .getTenantDetails(tenantName)
      .then((response) => {
        if (response.status === 200 && response.data) {
          localStorage.setItem("userName", userName);
          localStorage.setItem("tenantName", tenantName);
          dispatch(setTenantNameAction(tenantName));
          localStorage.setItem(
            "SecurityProviderName",
            response.data.SecurityProviderName
          );
          localStorage.setItem(
            "themeData",
            JSON.stringify(response.data?.ThemeData)
          );
          localStorage.setItem("tenantData", JSON.stringify(response?.data));
          dispatch(setThemeStylesHandler(response.data?.ThemeData));
          dispatch(preLoginAction(response.data));
        } else {
          dispatch(
            setErrorHandler(FAIL, "Invalid Organization ID or User name")
          );
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(loaders.common.pageLoader(false));
      });
  };

export const getTenantDetailsForAADFromURLActionHandler =
  (tenantName, navigate) => async (dispatch) => {
    dispatch(loaders.login.preLoginLoader(true));
    await apis.login
      .getTenantDetails(tenantName)
      .then((response) => {
        if (response.status === 200 && response.data) {
          if (response.data?.Status !== "Active") {
            dispatch(
              setErrorHandler(
                FAIL,
                "Your current subscription has expired. Please contact your administrator"
              )
            );
          } else {
            // localStorage.setItem("userName", userName);
            localStorage.setItem("tenantName", tenantName);
            dispatch(setTenantNameAction(tenantName));
            localStorage.setItem("tenantData", JSON.stringify(response?.data));
            localStorage.setItem(
              "SecurityProviderName",
              response.data.SecurityProviderName
            );
            localStorage.setItem(
              "themeData",
              JSON.stringify(response.data?.ThemeData)
            );
            dispatch(setThemeStylesHandler(response.data?.ThemeData));
            dispatch(preLoginAction(response.data));

            if (response.data.SecurityProviderName === "custom") {
              navigate(`/${tenantName}/login`);
              // navigate("/login");
            } else if (response.data.SecurityProviderName === "SAML2") {
              saveSAMLConfigAndRedirect(response.data);
              // return;
            } else if (response.data.SecurityProviderName === "aad") {
              navigate("/aadlogin");
            }
          }
        } else {
          if (response.data === null) {
            localStorage.removeItem("tenantName");
            navigate("/");
          }
          dispatch(
            setErrorHandler(FAIL, "Invalid Organization ID or User name")
          );
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(loaders.login.preLoginLoader(false));
      });
  };

export const preLoginActionHandler =
  (tenantName, userName, navigate, isConsentRequired, isClientId, isHybridFlow) =>
  async (dispatch) => {
    dispatch(loaders.login.preLoginLoader(true));
    await apis.login
      .preLogin(tenantName, userName, isConsentRequired, isClientId)
      .then((response) => {
        if (response.status === 200 && response.data) {
          if (response.data?.Status !== "Active") {
            dispatch(
              setErrorHandler(
                FAIL,
                "Your current subscription has expired. Please contact your administrator"
              )
            );
          } else {
            if (!isMatchingDomain(domains))
              if (userName !== undefined && userName !== null) {
                localStorage.setItem("userName", userName);
              }
            localStorage.setItem("tenantName", tenantName);
            dispatch(setTenantNameAction(tenantName));
            localStorage.setItem("tenantData", JSON.stringify(response?.data));
            localStorage.setItem(
              "SecurityProviderName",
              response.data.SecurityProviderName
            );
            localStorage.setItem(
              "themeData",
              JSON.stringify(response.data?.ThemeData)
            );
            dispatch(setThemeStylesHandler(response.data?.ThemeData));
            dispatch(preLoginAction(response.data));

            if (response.data.SecurityProviderName === "custom") {
              // Only lock the username on the login page when this came from a hybrid tenant's URL flow
              navigate(
                `/${tenantName}/login`,
                isHybridFlow ? { state: { hybridUserName: userName } } : undefined
              );
              // navigate("/login");
            } else if (response.data.SecurityProviderName === "SAML2") {
              localStorage.setItem("userName", userName);
              // SAML2 (plain or hybrid-SAML) always uses SSO; hybrid-custom is handled by the "custom" branch above
              saveSAMLConfigAndRedirect(response.data);
              // return;
            } else if (response.data.SecurityProviderName === "aad") {
              navigate("/aadlogin");
            }
          }
        } else {
          dispatch(
            setErrorHandler(FAIL, "Invalid Organization ID or User name")
          );
          if (isMatchingDomain(domains)) {
            navigate("/nopageFound");
          }
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(loaders.login.preLoginLoader(false));
      });
  };

export const getTenantDetailsWithTenantNameActionHandler =
  (tenantName, userName, navigate, isConsentRequired, isClientId) =>
  async (dispatch) => {
    dispatch(loaders.login.preLoginLoader(true));
    await apis.login
      .preLogin(tenantName, userName, isConsentRequired, isClientId)
      .then((response) => {
        if (response.status === 200 && response.data) {
          if (response.data?.Status !== "Active") {
            dispatch(
              setErrorHandler(
                FAIL,
                "Your current subscription has expired. Please contact your administrator"
              )
            );
          } else {
            if (!isMatchingDomain(domains))
              if (userName !== undefined && userName !== null) {
                localStorage.setItem("userName", userName);
              }
            localStorage.setItem("tenantName", tenantName);
            dispatch(setTenantNameAction(tenantName));
            localStorage.setItem("tenantData", JSON.stringify(response?.data));
            localStorage.setItem(
              "SecurityProviderName",
              response.data.SecurityProviderName
            );
            localStorage.setItem(
              "themeData",
              JSON.stringify(response.data?.ThemeData)
            );
            dispatch(setThemeStylesHandler(response.data?.ThemeData));
            dispatch(preLoginAction(response.data));

            if (response.data.SecurityProviderName === "custom") {
              navigate(`/${tenantName}/login`);
              // navigate("/login");
            } else if (response.data.SecurityProviderName === "SAML2") {
              // This handler is invoked from CheckTenantPage with userName=undefined
              // (no username form here), so never write it to localStorage, and never
              // include a "username" query param in the SAML redirect below.
              if (response.data?.SAMLConfig?.IdentityType === 2) {
                // Hybrid SAML: let user land on prelogin page, decide SSO/custom after username entry
                navigate("/", { state: { fromHybridTenant: true } });
              } else {
                localStorage.setItem(
                  "SAMLconfig",
                  JSON.stringify(response.data?.SAMLConfig)
                );
                localStorage.setItem(
                  "SAML2AuthServiceUrl",
                  response.data?.SAML2AuthServiceUrl
                );
                window.location.href =
                  response.data?.SAML2AuthServiceUrl +
                  tenantName +
                  "?web=" +
                  document.location.href;
              }
              // navigate(`/${tenantName}/login`);
            } else if (response.data.SecurityProviderName === "aad") {
              navigate("/aadlogin");
            }
          }
        } else {
          dispatch(
            setErrorHandler(FAIL, "Invalid Organization ID or User name")
          );
          if (isMatchingDomain(domains)) {
            navigate("/nopageFound");
          }
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(loaders.login.preLoginLoader(false));
      });
  };

//token not working for loginActionHandler (old admin portal login handler)
export const loginActionHandler =
  (userName, password, navigate) => async (dispatch) => {
    const data = {
      LoginId: userName,
      Password: password,
      PostLoginActions: true,
      UDID: 123,
      tenantName: localStorage.getItem("tenantName"),
    };
    await apis.login
      .login(data)
      .then((response) => {
        localStorage.setItem("token", response.data.TokenValue);
        localStorage.setItem("userName", userName);
        startTrackedSession();
        // localStorage.setItem("userPassword", password);
        dispatch(loginAction(response.data));
        navigate(`/${localStorage.getItem("tenantName")}/home`);
      })
      .catch((err) => {
        console.log(err);
      });
  };

//token working for loginActionHandler2 (new learner portal login handler)
export const loginActionHandler2 =
  (userName, password, navigate) => async (dispatch) => {
    dispatch(loaders.login.loginLoader(true));
    const data = {
      LoginId: userName,
      Password: password,
      PostLoginActions: true,
      UDID: 123,
      tenantName: localStorage.getItem("tenantName"),
    };
    await apis.login
      .login2(data)
      .then((response) => {
        if (response.status === 200 && response.data) {
          localStorage.setItem("token", response.data.TokenValue);
          localStorage.setItem("userName", userName);
          startTrackedSession();
          localStorage.setItem(
            "isResetRequired",
            response.data.IsResetRequired
          );
          if (response.data.IsResetRequired) {
            localStorage.setItem("userPassword", password);
          }
          dispatch(loginAction2(response.data));
          navigate(`/${localStorage.getItem("tenantName")}/home`);
        }
      })
      .catch((err) => {
        if (err.status === 412) {
          dispatch(
            setErrorHandler(
              FAIL,
              "Your current password has expired. Use 'Request New Password' to generate temporary password."
            )
          );
        } else if (err.status === 401) {
          if (err.data === "USERID_INACTIVE") {
            dispatch(setErrorHandler(FAIL, "UserId is inactive"));
            //dispatch(setErrorHandler(FAIL, "User credential(s) is/are incorrect."));
          } else if (err.data === "USERID_INCORRECT") {
            dispatch(
              setErrorHandler(FAIL, "User credential(s) is/are incorrect.")
            );
          }
          let lockType = err.data.split("|")[1];
          if (lockType === "TL") {
            dispatch(
              setErrorHandler(
                FAIL,
                "Please contact your administrator or try again after 30 minutes"
              )
            );
          } else if (lockType === "DL") {
            dispatch(
              setErrorHandler(
                FAIL,
                "Please contact your administrator to get the account unlocked"
              )
            );
          }
        } else if (err.status === 400) {
          let remainingAttempts = err.data.split("|")[1];
          if (remainingAttempts === "TL") {
            dispatch(
              setErrorHandler(
                FAIL,
                "Please contact your administrator or try again after 30 minutes"
              )
            );
          } else if (remainingAttempts === "DL") {
            dispatch(
              setErrorHandler(
                FAIL,
                "Please contact your administrator to get the account unlocked"
              )
            );
          } else {
            // dispatch(
            //   setErrorHandler(WARN, ``)
            // );
            dispatch(
              setErrorHandler(
                WARN,
                `User credential(s) is/are incorrect. You are left with ${remainingAttempts} more attempts before the account locks`
              )
            );
          }
        }
        // dispatch(
        //   setErrorHandler(
        //     FAIL,
        //     "An error occurred while processing your request."
        //   )
        // );
        console.log(err);
      })
      .finally(() => {
        dispatch(loaders.login.loginLoader(false));
      });
  };

export const logoutActionHandler = (navigate) => async (dispatch) => {
  const tenantName = localStorage.getItem("tenantName");
  const language = localStorage.getItem("language");
  const languageTerm = localStorage.getItem("languageTerm");
  const loginId = localStorage.getItem("userName");

  const tenantData = JSON.parse(localStorage.getItem("tenantData"));
  let securityProvider = localStorage.getItem("SecurityProviderName");
  setAndGetLocalLang(languageTerm, language, dispatch);
  localStorage.setItem("logout", Date.now());
  if (securityProvider === "SAML2") {
    if (tenantData?.SAML2AuthServiceUrl !== null) {
      let logoutUrl = `${tenantData?.SAML2AuthServiceUrl}login/Logout`;
      await endTrackedSessionNow();
      localStorage.clear();
      sessionStorage.clear();
      dispatch(logoutAction());
      window.location.href = logoutUrl;
    } else {
      await endTrackedSessionNow();
      localStorage.clear();
      sessionStorage.clear();
      dispatch(logoutAction());
      navigate(`/`);
    }
  } else if (securityProvider === "custom") {
    endTrackedSessionOnPageExit();
    apis.login
      .deleteUserToken(loginId)
      .then((response) => {
        if (response.status === 204) {
          // localStorage.clear();
          // sessionStorage.clear();
          // dispatch(loginActionCreator.logOutAction());
          // navigate("/");
        }
      })
      .catch((error) => {
        console.log("error " + error);
      });
    localStorage.clear();
    sessionStorage.clear();
    dispatch(logoutAction());
    if (tenantName) {
      navigate(`/${tenantName}/login`);
    } else {
      navigate(`/`);
    }
  } else {
    const msalInstance = new msal.PublicClientApplication(msalConfig);
    const token = localStorage.getItem("token");
    await endTrackedSessionNow();
    apis.login
      .revokeTokenOnLogout(token)
      .then((response) => {
        console.log("Logout response status:", response.status);
        localStorage.clear();
        sessionStorage.clear();
        dispatch(logoutAction());
        msalInstance.logoutRedirect();
      })
      .catch((error) => {
        console.error("Logout error:", error);
        localStorage.clear();
        sessionStorage.clear();
        dispatch(logoutAction());
        msalInstance.logoutRedirect();
      });
  }
};

export const isUserActiveActionHandler = (id, tenant) => async (dispatch) => {
  return await apis.login.IsUserActive(id, tenant).then((response) => {
    if (response) {
      return response;
    }
  });
};

export const lastLoginTimeActionHandler =
  (lastlogintime) => async (dispatch) => {
    const data = {
      LastLoginTime: lastlogintime,
    };
    await apis.login
      .lastLogin(data)
      .then((response) => {
        dispatch(lastLoginTimeAction(response.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const forgotPasswordActionHandler =
  (loginId, tenantName) => async (dispatch) => {
    dispatch(loaders.login.requestNewPasswordLoader(true));
    const data1 = {
      isResetRequired: true,
      loginId: loginId,
      tenantName: tenantName,
    };
    const data2 = {
      IsAdminPortal: true,
      loginId: loginId,
      tenantName: tenantName,
    };
    return await apis.login
      .IsUserExist(loginId, tenantName)
      .then(async (response) => {
        if (response.data === true) {
          return await apis.login
            .IsUserExist(loginId, tenantName)
            .then(async (response) => {
              if (response.data === true) {
                return await apis.login
                  .isPasswordResetRequired(data1)
                  .then(async (response) => {
                    if (response.data === true) {
                      return await apis.login
                        .forgotPassword(data2)
                        .then((response) => {
                          if (response !== undefined) {
                            dispatch(
                              setErrorHandler(
                                SUCCESS,
                                "An email has been sent to your registered email address"
                              )
                            );
                          }
                        })
                        .catch((err) => {
                          console.log(err);
                        })
                        .finally(() => {
                          dispatch(
                            loaders.login.requestNewPasswordLoader(false)
                          );
                        });
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const changePasswordActionHandler =
  (currentPassword, newPassword) => async (dispatch) => {
    dispatch(loaders.login.changePasswordLoader(true));
    const data = {
      OldPassword: currentPassword,
      NewPassword: newPassword,
    };
    return await apis.profile
      .resetPassword(data)
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        dispatch(loaders.login.changePasswordLoader(false));
      });
  };
